<template>
     <!-- Custom tabs (Charts with tabs)-->
            <div class="card">
              <div class="card-header d-flex p-0">
                <h3 class="card-title p-3">
                  <i class="fas fa-chart-pie mr-1"></i>
                     {{title}}
                </h3>
     
              </div><!-- /.card-header -->
              <div class="card-body">
                <div class="tab-content p-0">
                  <!-- Morris chart - Sales -->
                  <div v-if="loaded && chartdata.length > 0" style="position: relative;">

                       <component
                       :is="'top-country-chart'"
                       :height="200" 
                        style="height: auto;"
                       :chartdata="chartdata"
                       :chartlabels="chartlabels"
                      
                       />
                   </div>
                      <div v-else style="position: relative;">
                         <img :src="Icon" width="300" height="auto">
                   </div>
     
                </div>
              </div><!-- /.card-body -->
            </div>
            <!-- /.card -->
</template>

<script>


import DoughnutChart from "./DoughnutChart.vue";
import Icon from "@/assets/Icon.svg";

export default {

    components:{
        "top-country-chart" : DoughnutChart
    },

  props: {
    chartdata: {
      type: Array,
      default: []
    },
    chartlabels: {
      type: Array,
      default: []
    },
     title: {
      type: String,
      required: true
    }
  },

  data(){

      return {
          Icon,
          loaded:true
      }

  }
}
</script>